import { Injectable, inject } from '@angular/core';
import {NetworkService} from '../../../../../../projects/common/src/lib/services/network.service';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';
import {SupportPost, SupportState, SupportTicketSummary, SupportTicketView} from '../../../../dashboard/support/support.model';

/** A file of a message, uploaded before it is sent: the server moves it beside the request. */
export interface OutgoingFile {
  upload: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class SupportApiService extends BaseApiService {

  constructor() {

    super();
  }

  // ── The customer's requests (Support page) ─────────────────────────

  /** The account's requests, the latest activity first. */
  listTickets() {
    return this.get<{tickets: SupportTicketSummary[]}>('/support/tickets');
  }

  /** How many requests have an answer the account has not read. */
  unreadCount() {
    return this.get<{count: number}>('/support/unread');
  }

  /** One request with its whole conversation; opening it marks our replies read. */
  getTicket(id: string) {
    return this.get<SupportTicketView>(`/support/tickets/${encodeURIComponent(id)}`);
  }

  /** A new request: through the same filing as before (team email, receipt), with its files. */
  createTicket(data: {type: string, subject: string, message: string, files: OutgoingFile[], app: string,
                      appVersion: string, deviceInfo: any, language: string}) {
    return this.post<{ticket: SupportTicketView}>('/support/tickets', data);
  }

  /** The customer writes in a request; a closed one opens again. */
  postMessage(id: string, text: string, files: OutgoingFile[]) {
    return this.post<{post: SupportPost, status: 'open' | 'closed', state: SupportState}>(
      `/support/tickets/${encodeURIComponent(id)}/messages`, {text, files});
  }

  /** The customer's problem is solved. */
  closeTicket(id: string) {
    return this.post<{status: 'closed', state: SupportState}>(`/support/tickets/${encodeURIComponent(id)}/close`, {});
  }

}
